import { TraitRegistryItem } from '../TraitRegistryItem';
import { AttachedContext } from '../../../classes/context/AttachedContext';
import { runtime } from '../../../classes/runtime/Runtime';
export class TraitTypeSelectWithPreview extends TraitRegistryItem {
    constructor(init = {}) {
        super(init);
        Object.assign(this, init);
    }
    select;
    onMouseEnter({ at, selectItem }) {
        at.trait.traitEdit.temporaryValue = at.trait.value;
        at.trait.value = selectItem[0];
    }
    onMouseLeave({ at, selectItem }) {
        if (typeof at.trait.traitEdit.temporaryValue !== 'undefined') {
            at.trait.value = at.trait.traitEdit.temporaryValue;
        }
        at.trait.traitEdit.temporaryValue = undefined;
    }
    get selectItems() {
        return this.select || runtime.solidPackages.Edit.registryMetaInfo.traits[this.key].select || [];
    }
}
export class SelectWithPreviewContext extends AttachedContext {
    selectItem;
    constructor(at, selectItem) {
        super(at);
        this.selectItem = selectItem;
    }
}
